import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {Box} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {ChevronLeft} from '@jobseeker/lotus/icons';
import {PropTypes} from '../type';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
  '.MuiDialog-paper': {
    borderRadius: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    '.MuiDialog-paper': {
      borderRadius: theme.spacing(0),
    },
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  // '& .MuiDialogActions-root': {
  //   padding: theme.spacing(1),
  // },
}));

const Component = ({
  title,
  subtitle,
  invertedTitle,
  onDoneClick,
  ...props
}: PropTypes) => {
  const theme = useWrappedTheme();
  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event, 'escapeKeyDown');
  };

  const isLarge = useIsLargeDevice();

  return (
    <div>
      <BootstrapDialog
        {...props}
        fullScreen
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            height: '100%',
            borderRadius: 0,
            margin: 0,
          },
        }}
      >
        <Box
          sx={{
            py: subtitle ? 0 : 1,
            // overflow: 'hidden',
            // position: 'relative',
            background: '#FFFFFF',
            pr: 6,
            borderBottom: '1px solid #EEEEEE',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: '7px',
          }}
        >
          <Box display={'flex'} justifyContent={'center'} padding={0}>
            <IconButton
              onClick={handleClose}
              sx={{transform: 'rotate(180deg)', padding: 0}}
            >
              <Image
                width={24}
                height={24}
                src={ChevronLeft}
                alt={'Back'}
                onClick={handleClose}
              />
            </IconButton>

            <DialogTitle sx={{px: '16px'}}>
              {invertedTitle ? (
                <>
                  {subtitle && (
                    <Typography color="primary.contrastText" variant="body2">
                      {subtitle}
                    </Typography>
                  )}
                  <Typography
                    color="primary.contrastText"
                    fontSize={{xxs: 18, md: 20}}
                    fontWeight={600}
                  >
                    {title}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    color="#333333"
                    fontSize={{xxs: 14}}
                    fontWeight={500}
                  >
                    {title}
                  </Typography>
                  {subtitle && (
                    <Typography
                      color="#7E7E7E"
                      fontSize={{xxs: 12}}
                      fontWeight={400}
                    >
                      {subtitle}
                    </Typography>
                  )}
                </>
              )}
            </DialogTitle>
          </Box>
          <Typography
            sx={{
              color: isAppIimjobs ? '#49966E' : theme.palette.primary.main,
              cursor: 'pointer',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: '16px',
              letterSpacing: '0.56px',
              marginRight: '16px',
            }}
            onClick={e => {
              if (onDoneClick) {
                onDoneClick();
              }
              handleClose(e);
            }}
          >
            Done
          </Typography>
        </Box>

        <DialogContent sx={{padding: 0}}>{props.children}</DialogContent>
        {props.footer}
      </BootstrapDialog>
    </div>
  );
};

export default Component;
